import { render, staticRenderFns } from "./MessagingTrigger.vue?vue&type=template&id=5be5a5d0&scoped=true&"
import script from "./MessagingTrigger.vue?vue&type=script&lang=js&"
export * from "./MessagingTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be5a5d0",
  null
  
)

export default component.exports